import React, { useState, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { FaBars, FaTimes } from "react-icons/fa"; // Iconos de menú
import headerLogo from "../assets/img/hoy-vemos-header.svg"; // Logo principal
import sidebarLogo from "../assets/img/hoyvemoslogo.svg"; // Logo dentro del sidebar

const Header = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const homeUrl = "/";

  const handleLogin = (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  return (
    <>
      {/* HEADER */}
      <header className="bg-[#1d4ed8] text-white sticky top-0 z-30 shadow-md">
        <div className="container mx-auto flex justify-between items-center py-4 px-6">
          {/* Logo principal en el header */}
          <div className="flex items-center space-x-4">
            <a href={homeUrl}>
              <img src={headerLogo} alt="Logo Principal" className="h-10 w-auto" />
            </a>
            <div>
              <h1 className="text-2xl font-bold">
                <a href={homeUrl} className="hover:text-[#f3f4f6]">¡Hoy Vemos!</a>
              </h1>
              <p className="text-sm text-gray-200">Películas & Series</p>
            </div>
          </div>

          {/* Botón de menú hamburguesa */}
          <button
            onClick={() => setSidebarOpen(true)}
            className="text-white text-2xl p-2 hover:bg-blue-600 rounded-md focus:outline-none"
          >
            <FaBars />
          </button>
        </div>
      </header>

      {/* BACKDROP (Fondo oscuro al abrir el sidebar) */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity ${
          isSidebarOpen ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
        onClick={() => setSidebarOpen(false)}
      ></div>

      {/* SIDEBAR DERECHO (OFFCANVAS) */}
      <aside
        className={`fixed right-0 top-0 w-80 h-full bg-white shadow-xl transform z-40 ${
          isSidebarOpen ? "translate-x-0" : "translate-x-full"
        } transition-transform duration-300 ease-in-out`}
      >
        {/* Encabezado del Sidebar */}
        <div className="flex justify-between items-center p-4 border-b">
          <img src={sidebarLogo} alt="Logo Sidebar" className="h-10 w-auto" />
          <button
            onClick={() => setSidebarOpen(false)}
            className="text-gray-700 hover:text-red-500 text-xl"
          >
            <FaTimes />
          </button>
        </div>

        {/* Contenido del Sidebar */}
        <div className="p-6">
          <h1 className="text-center text-2xl font-bold text-gray-800 mb-2">Bienvenido</h1>
          <p className="text-center text-gray-600 mb-6">
            ¡Inspírate con Hoy Vemos! <br />
            Soporte técnico para plataformas gestionadas por terceros.
          </p>

          {/* FORMULARIO DE INGRESO */}
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Correo</label>
              <input
                type="email"
                placeholder="Ingresa tu correo"
                className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Contraseña</label>
              <input
                type="password"
                placeholder="********"
                className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>

            <button
              type="submit"
              className="w-full py-2 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600"
            >
              Ingresar
            </button>
          </form>

          {/* OPCIONES ADICIONALES */}
          <div className="text-center mt-4 text-sm text-gray-500">
            <a href="#" className="text-blue-600 hover:underline">
              ¿Olvidó su contraseña?
            </a>
          </div>

          <div className="text-center mt-2 text-sm text-gray-500">
            ¿Aún no tienes una cuenta?{" "}
            <a href="/registro" className="text-blue-600 hover:underline">
              Regístrate aquí
            </a>
          </div>
        </div>

        {/* Pie de página del Sidebar */}
        <div className="absolute bottom-0 w-full p-4 text-center bg-gray-100 border-t text-gray-600">
          Hoy Vemos 2025
        </div>
      </aside>

      {/* MODAL ALERTA (z-50 para estar encima del sidebar) */}
      <Transition appear show={isModalOpen} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={() => setIsModalOpen(false)}>
          <div className="fixed inset-0 bg-black bg-opacity-25 flex items-center justify-center">
            <Dialog.Panel className="bg-white p-6 rounded-lg shadow-lg max-w-md">
              <Dialog.Title className="text-lg font-bold text-gray-900 text-center">
                Inicio de Sesión en Mantenimiento
              </Dialog.Title>
              <p className="text-gray-600 text-center mt-2">
                Nuestro sistema de inicio de sesión está en mantenimiento. <br />
                Inténtalo más tarde. ¡Gracias por tu comprensión!
              </p>
              <button
                className="mt-4 w-full bg-red-600 text-white py-2 rounded-md hover:bg-red-700"
                onClick={() => setIsModalOpen(false)}
              >
                Cerrar
              </button>
            </Dialog.Panel>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default Header;
